// extracted by mini-css-extract-plugin
export default {"cls1":"SocialEditor-cls1__e716745fb0748a1867fd","cls2":"SocialEditor-cls2___83b5075bd19ed4a0e2f SocialEditor-cls1__e716745fb0748a1867fd"};